var render = function render(_c,_vm){return _c('button',_vm._g(_vm._b({class:['bravado-icon-button', `bravado-icon-button--${_vm.props.variant}`]},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }